module.exports = __webpack_public_path__ + "img/Psych_text03_meaning.0414cd79.png";